import { css } from 'styled-components';

const BoxShadow = () => {
    return (
        css`
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.12);
          transition: box-shadow 0.2s ease-in-out;
        `
    )
}


export default BoxShadow;